module.exports = __webpack_public_path__ + "img/philodendron.60fabd41.webp";